import { SignupConsts } from 'client/util/Constants';

export default {
  ...SignupConsts.SignupOptions,
};
